export default __webpack_public_path__ + "static/eyimisan-8be06abe9e2bf5abab0779baeab01b38.png";